/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Autocomplete,
  CircularProgress,
  Collapse,
  Grid,
  Paper,
  TextField,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import style from "./Orders.module.scss";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useEffect, useState } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import moment from "moment";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { getData } from "../../Services/getData";
import { UrlEnum } from "../../Utils/Utils";
import FanCourierComponent, { FanCourierOverrides } from "./FanCourierComponent";
import DividerWithLabel from "../Common/DividerWithLabel";

type OrderShippingProps = {
  shipping: OrderShippingState;
  fanCourierInfo: any;
  fanCourierInfoReturn?: any;
  order: any;
  handleChangeOrder: (order: any) => void;
  handleChangeShipping: (shipping: OrderShippingState) => void;
  saveOrder: (order: any) => Promise<any>;
  fanCourierOverrides?: FanCourierOverrides;
};

export class OrderShippingState {
  pickupDate = moment().format("YYYY-MM-DD");
  county = "";
  city = "";
  street = "";
  number = "";
  details = "";
  zipCode = "";
}

export default function OrderShipping(props: OrderShippingProps) {
  const {
    shipping,
    fanCourierInfo,
    fanCourierInfoReturn,
    order,
    handleChangeOrder,
    handleChangeShipping,
    fanCourierOverrides,
  } = props;
  const [localShipping, setLocalShipping] = useState<OrderShippingState>(
    new OrderShippingState()
  );
  const [openCollapse, setOpenCollapse] = useState(false);
  const [loading, setLoading] = useState(false);
  const [localities, setLocalities] = useState([]);
  const [cities, setCities] = useState([]);
  const [streets, setStreets] = useState([]);

  useEffect(() => {
    if (shipping) {
      setLocalShipping(shipping);
    }
    if (localities.length === 0) {
      getLocations();
    }
    if (shipping && shipping.county && shipping.county !== "") getCities();
    if (
      shipping &&
      shipping.county &&
      shipping.county !== "" &&
      shipping.city &&
      shipping.city !== ""
    ) {
      getStreets();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shipping?.county, shipping?.city]);

  /**
   *
   */
  async function getLocations() {
    setLoading(true);
    const res = await getData(UrlEnum.localities);
    if (res && res.data) {
      setLocalities(res.data);
    }
    setLoading(false);
  }

  /**
   *
   */
  async function getCities() {
    setLoading(true);
    const res = await getData(`${UrlEnum.cities}/${shipping.county}`);
    if (res && res.data) {
      setCities(res.data);
    }
    setLoading(false);
  }

  /**
   *
   */
  async function getStreets() {
    setLoading(true);
    const res = await getData(
      `${UrlEnum.streets}/${shipping.county}/${shipping.city}`
    );
    if (res && res.data) {
      setStreets(res.data);
    }
    setLoading(false);
  }

  /**
   *
   * @param value
   */
  function handleOpenCollapse(value: boolean) {
    setOpenCollapse(value);
  }

  const isWeekend = (date: any) => {
    const day = date.day();
    return day === 0 || day === 6;
  };

  return (
    <Grid
      item
      xs={12}
      md={12}
      lg={12}
      style={{ margin: "10px 10px 40px 10px" }}
    >
      <Paper
        style={{
          padding: 15,
        }}
      >
        <div
          className={style.collapse}
          onClick={() => handleOpenCollapse(!openCollapse)}
        >
          <h3>{Vocabulary.shipping}</h3>
          {openCollapse ? (
            <KeyboardArrowUpIcon className={style.arrowIcon} />
          ) : (
            <KeyboardArrowDownIcon className={style.arrowIcon} />
          )}
        </div>
        <Collapse in={openCollapse} unmountOnExit>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label={Vocabulary.pickupDate}
                  inputFormat="DD-MM-YYYY"
                  value={moment(localShipping.pickupDate)}
                  onChange={(e: any) => {
                    setLocalShipping({
                      ...localShipping,
                      pickupDate: e.format("YYYY-MM-DDTHH:mm:ss"),
                    });
                    handleChangeShipping({
                      ...localShipping,
                      pickupDate: e.format("YYYY-MM-DDTHH:mm:ss"),
                    });
                  }}
                  renderInput={(params) => (
                    <TextField size="small" fullWidth {...params} />
                  )}
                  shouldDisableDate={isWeekend}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={6} lg={6}></Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Autocomplete
                options={localities}
                value={localShipping.county || ""}
                onChange={(event, newValue) => {
                  setLocalShipping({
                    ...localShipping,
                    county: newValue || "",
                    city: "",
                    street: "",
                  });
                  handleChangeShipping({
                    ...localShipping,
                    county: newValue || "",
                    city: "",
                    street: "",
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={Vocabulary.county}
                    name="county"
                    variant="standard"
                    size="small"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Autocomplete
                options={cities}
                value={localShipping.city || ""}
                onChange={(event, newValue) => {
                  setLocalShipping({
                    ...localShipping,
                    city: newValue || "",
                    street: "",
                  });
                  handleChangeShipping({
                    ...localShipping,
                    city: newValue || "",
                    street: "",
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={Vocabulary.city}
                    name="city"
                    variant="standard"
                    size="small"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Autocomplete
                options={streets}
                value={localShipping.street || ""}
                onChange={(event, newValue) => {
                  setLocalShipping({
                    ...localShipping,
                    street: newValue || "",
                  });
                  handleChangeShipping({
                    ...localShipping,
                    street: newValue || "",
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label={Vocabulary.street}
                    name="street"
                    size="small"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <TextField
                type="text"
                label={Vocabulary.number}
                variant="standard"
                fullWidth
                value={localShipping.number}
                onChange={(e) => {
                  setLocalShipping({
                    ...localShipping,
                    number: e.target.value,
                  });
                  handleChangeShipping({
                    ...localShipping,
                    number: e.target.value,
                  });
                }}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <TextField
                type="text"
                label={Vocabulary.zipCode}
                variant="standard"
                fullWidth
                value={localShipping.zipCode}
                onChange={(e) => {
                  setLocalShipping({
                    ...localShipping,
                    zipCode: e.target.value,
                  });
                  handleChangeShipping({
                    ...localShipping,
                    zipCode: e.target.value,
                  });
                }}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <TextField
                type="text"
                label={Vocabulary.details}
                variant="standard"
                fullWidth
                value={localShipping.details}
                onChange={(e) => {
                  setLocalShipping({
                    ...localShipping,
                    details: e.target.value,
                  });
                  handleChangeShipping({
                    ...localShipping,
                    details: e.target.value,
                  });
                }}
              />
            </Grid>
          </Grid>
          <DividerWithLabel label="Fan Courier" />
          <FanCourierComponent
            fanCourierInfo={fanCourierInfo}
            fanCourierInfoReturn={fanCourierInfoReturn}
            order={order}
            handleChangeOrder={handleChangeOrder}
            saveOrder={props.saveOrder}
            overrides={fanCourierOverrides}
          />
        </Collapse>
        {loading ? (
          <div className="loading">
            <CircularProgress color="primary" />
          </div>
        ) : null}
      </Paper>
    </Grid>
  );
}
